import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class OrdersService {

  public GET_ORDER_BY_ID: any;
  public UPDATE_ORDER_BY_ORDER_ID:any;

  constructor(
    public apollo: Apollo

  ) {
    this.GET_ORDER_BY_ID = gql`
    query GetOrders($input:Int!) {
      allOrders(condition:{id:$input}) {
         nodes{
          id
          nodeId
          archive
          orderContent
          orderStatusesByOrderId(orderBy:ID_DESC,first:1){
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
      }
     

  } `;
  this.UPDATE_ORDER_BY_ORDER_ID = gql `
  mutation updateOrderDate($input:UpdateOrderByIdInput!){
    updateOrderById(input:$input){
      order{
        createdAt
        orderedDate
        id
      }
    }
  }
  `;
  }

  /*Get allocated & accepted orders*/
  FETCH_ORDER_BY_ID(id): any {
    return this.apollo.watchQuery({
      query: this.GET_ORDER_BY_ID,
      variables: {
        "input": Number.parseInt(id)
      },
      fetchPolicy: 'network-only',
    });
  }
  UPDATE_ORDER_BY_ORDERID(orderId) {

    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_BY_ORDER_ID,
      variables: {
          "input": {
            "id": orderId,
            "orderPatch": {
              "orderedDate": new Date()
            }
          }
        
      },
      fetchPolicy: 'no-cache'
    })
  }

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/main/content/gql-query-mutation/orders.service.ts